import { useState, useEffect, ReactNode } from 'react';
import { useAuth } from './auth';
import { YearContext } from './yearContextDef';

export { YearContext } from './yearContextDef';

export function YearProvider({ children }: { children: ReactNode }) {
  const { getToken, user } = useAuth();
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [availableYears, setAvailableYears] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return; // aguardar autenticação antes de buscar
    getToken().then(token => {
      if (!token) { setLoading(false); return; }
      fetch('/api/events/years', { headers: { Authorization: 'Bearer ' + token } })
        .then(r => r.json())
        .then((data: unknown) => {
          const years = Array.isArray(data) ? (data as number[]) : [];
          if (years.length === 0) {
            setAvailableYears([currentYear]);
          } else {
            setAvailableYears(years);
            if (!years.includes(currentYear)) {
              setSelectedYear(years[years.length - 1]);
            }
          }
        })
        .catch(() => setAvailableYears([currentYear]))
        .finally(() => setLoading(false));
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // re-executa quando user mudar (login)

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear, availableYears, loading }}>
      {children}
    </YearContext.Provider>
  );
}
